import { render } from "./ListPublicacionesClientes.vue?vue&type=template&id=37d32d2a&scoped=true"
import script from "./ListPublicacionesClientes.vue?vue&type=script&lang=js"
export * from "./ListPublicacionesClientes.vue?vue&type=script&lang=js"

import "./ListPublicacionesClientes.vue?vue&type=style&index=0&id=37d32d2a&scoped=true&lang=css"

import exportComponent from "C:\\paginascedis\\general\\cedispage2.0_general_cecra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37d32d2a"]])

export default __exports__